"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LayerSwitcher = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Map = _interopRequireDefault(require("ol/Map"));
var _Group = _interopRequireDefault(require("ol/layer/Group"));
var _Tile = _interopRequireDefault(require("ol/layer/Tile"));
var _constants = require("../constants");
var _MapComponent = _interopRequireDefault(require("../Map/MapComponent/MapComponent"));
require("./LayerSwitcher.less");
var _excluded = ["identifierProperty", "labelProperty", "map", "layers", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @export
 * @interface LayerSwitcherProps
 * @extends {React.HTMLAttributes<HTMLDivElement>}
 */

/**
 * Class representing the LayerSwitcher.
 * A basic component to switch between the passed layers.
 * This is most likely to be used for the backgroundlayer.
 *
 * @class LayerSwitcher
 * @extends React.Component
 */
var LayerSwitcher = exports.LayerSwitcher = function LayerSwitcher(_ref) {
  var _ref$identifierProper = _ref.identifierProperty,
    identifierProperty = _ref$identifierProper === void 0 ? 'name' : _ref$identifierProper,
    _ref$labelProperty = _ref.labelProperty,
    labelProperty = _ref$labelProperty === void 0 ? 'name' : _ref$labelProperty,
    map = _ref.map,
    layers = _ref.layers,
    classNameProp = _ref.className,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  /**
   * The internal map of the LayerSwitcher
   * @private
   */
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    switcherMap = _useState2[0],
    setSwitcherMap = _useState2[1];

  /**
   * The internal index of visible layer in provided layers array. If all passed
   * layers are initially invisible, the first layer in array will be taken as
   * default.
   * @private
   */
  var visibleLayerIndexRef = (0, _react.useRef)(0);
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    previewLayer = _useState4[0],
    setPreviewLayer = _useState4[1];

  /**
   * The className added to this component.
   * @private
   */
  var className = "".concat(_constants.CSS_PREFIX, "layer-switcher");
  (0, _react.useEffect)(function () {
    var mapClone = new _Map["default"]({
      view: map.getView(),
      controls: []
    });
    setSwitcherMap(mapClone);
    return function () {
      if (switcherMap) {
        switcherMap.getLayers().clear();
        switcherMap.setTarget(undefined);
        setSwitcherMap(undefined);
      }
    };
  }, [map]);
  (0, _react.useEffect)(function () {
    if (switcherMap) {
      switcherMap.getLayers().clear();
      layers.map(cloneLayer).forEach(function (layer) {
        return switcherMap.addLayer(layer);
      });
    }
    updateLayerVisibility();
  }, [switcherMap]);

  /**
   * Clones a layer
   *
   * @param layer The layer to clone.
   * @returns The cloned layer.
   */
  function cloneLayer(layer) {
    if (layer instanceof _Group["default"]) {
      return new _Group["default"](_objectSpread({
        layers: layer.getLayers().getArray().map(function (l) {
          if (!(l instanceof _Tile["default"]) || !(l instanceof _Group["default"])) {
            throw new Error('Layer of layergroup is of unclonable type');
          }
          return cloneLayer(l);
        }),
        properties: {
          originalLayer: layer
        }
      }, layer.getProperties()));
    } else {
      var clone = new _Tile["default"](_objectSpread({
        source: layer.getSource() || undefined,
        properties: {
          originalLayer: layer
        }
      }, layer.getProperties()));
      // reset reference to the map instance of original layer
      clone.setMap(null);
      return clone;
    }
  }
  ;

  /**
   * Sets the visiblity of the layers in the props.map and this._map.
   * Also sets the previewLayer in the state.
   *
   */
  var updateLayerVisibility = function updateLayerVisibility() {
    layers.forEach(function (l, i) {
      var _switcherMap$getAllLa;
      var visible = visibleLayerIndexRef.current === i;
      l.setVisible(visible);
      var clone = switcherMap === null || switcherMap === void 0 || (_switcherMap$getAllLa = switcherMap.getAllLayers()) === null || _switcherMap$getAllLa === void 0 ? void 0 : _switcherMap$getAllLa.find(function (lc) {
        return lc.get(identifierProperty) === l.get(identifierProperty);
      });
      if (clone) {
        clone.setVisible(visible);
        if (visible) {
          setPreviewLayer(clone);
        }
      }
    });
  };

  /**
   * Clickhandler for the overview switch.
   *
   */
  var onSwitcherClick = function onSwitcherClick(evt) {
    evt.stopPropagation();
    layers.forEach(function (layer, index) {
      if (layer.getVisible()) {
        if (layers.length - 1 === index) {
          visibleLayerIndexRef.current = 0;
        } else {
          visibleLayerIndexRef.current = index + 1;
        }
      }
    });
    updateLayerVisibility();
  };

  /**
   * The render function.
   */
  var finalClassName = classNameProp ? "".concat(className, " ").concat(classNameProp) : className;
  if (!switcherMap) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: finalClassName,
    role: "menu"
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clip",
    onClick: onSwitcherClick,
    role: "button"
  }, /*#__PURE__*/_react["default"].createElement(_MapComponent["default"], {
    mapDivId: "layer-switcher-map",
    map: switcherMap,
    role: "presentation"
  }), previewLayer && /*#__PURE__*/_react["default"].createElement("span", {
    className: "layer-title"
  }, previewLayer === null || previewLayer === void 0 ? void 0 : previewLayer.get(labelProperty))));
};
var _default = exports["default"] = LayerSwitcher;